module.exports = __webpack_public_path__ + "assets/69b30e19c968f8e24f8094a45956a813.mp3";